import { formatDistanceToNow } from "date-fns";
import type { IdeaStageInput } from "@/components/new-look/stage";
import type { EpicRequest } from "@/lib/api/epic-requests";

/** Helpers shared by the All ideas list and board. */

export function clarityTone(score: number): string {
  if (score >= 85) return "text-green-700 dark:text-green-300";
  if (score >= 60) return "text-amber-700 dark:text-amber-300";
  return "text-muted-foreground";
}

export function updatedAgo(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? "" : formatDistanceToNow(date, { addSuffix: true });
}

/** What stageOf needs, from the request and its build facts. */
export function factsFor(idea: EpicRequest): IdeaStageInput {
  const f = idea.facts;
  return {
    request: idea,
    epic: f?.epic
      ? {
          state: f.epic.state,
          displayState: f.epic.displayState,
          completedFeatureCount: f.epic.completedFeatureCount,
          featureCount: f.epic.featureCount,
        }
      : null,
    planJob: f?.planJob ?? null,
    buildJob: f?.buildJob ?? null,
    openPullRequests: f?.openPullRequests ?? 0,
  };
}

/** Share of the blueprint's parts done, or null before there is one. */
export function progressOf(idea: EpicRequest, stage: string): number | null {
  if (stage === "done") return 100;
  const epic = idea.facts?.epic;
  if (!epic || epic.featureCount === 0) return null;
  return Math.round((epic.completedFeatureCount / epic.featureCount) * 100);
}
